import { useEffect, useState } from "react";
import axios from "axios";
import { staticContentDefaults } from "../data/staticContentDefaults";

const LOG_PREFIX = "[StaticContent]";

const logContentSource = (slug, source, detail = "") => {
  const message = detail
    ? `${LOG_PREFIX} ${slug} → ${source} (${detail})`
    : `${LOG_PREFIX} ${slug} → ${source}`;

  if (source.includes("database")) {
    console.info(message);
  } else {
    console.warn(message);
  }
};

export const useStaticPageContent = (slug) => {
  const defaults = staticContentDefaults[slug] || {};
  const [content, setContent] = useState(defaults);

  useEffect(() => {
    if (Object.keys(defaults).length > 0) {
      logContentSource(
        slug,
        "staticContentDefaults.js",
        "initial render / fallback file"
      );
    } else {
      logContentSource(
        slug,
        "staticContentDefaults.js",
        "no defaults found for this slug"
      );
    }

    let cancelled = false;

    const fetchContent = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_APP_BASE_URL}/api/static-content/${slug}`,
          {
            headers: {
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
            },
          }
        );

        if (cancelled) return;

        if (response?.data?.data?.content) {
          setContent(response.data.data.content);
          logContentSource(
            slug,
            "database (StaticPageContents table)",
            `loaded from ${import.meta.env.VITE_APP_BASE_URL}/api/static-content/${slug}`
          );
          return;
        }

        logContentSource(
          slug,
          "staticContentDefaults.js",
          "API responded but content was empty — keeping fallback file data"
        );
      } catch (error) {
        if (cancelled) return;
        logContentSource(
          slug,
          "staticContentDefaults.js",
          `API failed (${error?.message}) — using fallback file data`
        );
      }
    };

    void fetchContent();

    const onFocus = () => {
      void fetchContent();
    };
    window.addEventListener("focus", onFocus);

    return () => {
      cancelled = true;
      window.removeEventListener("focus", onFocus);
    };
  }, [slug]);

  return content;
};
